import FrecuentAskedQuestions from "../components/FrecuentAskedQuestions";
import SocialMedia from "../components/SocialMedia";
import GetInTouch from "../components/GetInTouch";
import SimpleFooter from "../components/SimpleFooter";
import PokemonMessage from "../components/PokemonMessage";
import { useMediaQuery } from "react-responsive";

function Contact() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return (
    <div>
      <div className="pisibleGrid">
        <section className="sec" id="img-pokemon-contact">
          <div className="messAbsolute">
            <PokemonMessage isMobile={isMobile} />
          </div>

          <div className="jiggly-container">
            <img
              alt="jigglypuff"
              className="pokemon-mess-jiggly"
              src="https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/home/175.png"
              title="pokemon-message"
            />
          </div>
        </section>

        {/* --------------------------------- */}
        <section className="sec" id="form-contact">
          <GetInTouch />
        </section>
        {/* --------------------------------- */}
        <section className="sec" id="social-media">
          <SocialMedia />
        </section>
        {/* --------------------------------- */}
        <section className="sec" id="faq-contact">
          <FrecuentAskedQuestions />
        </section>
        {/* --------------------------------- */}
      </div>
      <SimpleFooter />
    </div>
  );
}

export default Contact;
